export default function NewsLoading() {
    return (
        <>
            {
                [...Array(6)].map((_, i) => (
                    <div className="w-full h-60 space-y-2 m-2" key={i}>
                        <div className="h-full w-full rounded-md l-load"></div>
                        <div className="w-8/12 h-4 rounded-md l-load-dt"></div>
                    </div>
                ))
            }
        </>
    )
}